import { Header } from "@/components/site/Header";
import { HeroAfter } from "@/components/site/HeroAfter";
import { ProofGrid } from "@/components/site/ProofGrid";
import { Services } from "@/components/site/Services";
import { TrustBlock } from "@/components/site/TrustBlock";
import { Reviews } from "@/components/site/Reviews";
import { About } from "@/components/site/About";
import { CtaClose } from "@/components/site/CtaClose";
import { Footer } from "@/components/site/Footer";
import { MobileCallBar } from "@/components/site/MobileCallBar";
import { LeadFunnelProvider } from "@/contexts/LeadFunnelContext";

const Index = () => {
  return (
    <LeadFunnelProvider>
      <div className="min-h-screen bg-background pb-16 lg:pb-0">
        <Header />
        <main>
          <HeroAfter />
          <ProofGrid />
          <Services />
          <TrustBlock />
          <Reviews />
          <About />
          <CtaClose />
        </main>
        <Footer />
        <MobileCallBar />
      </div>
    </LeadFunnelProvider>
  );
};

export default Index;
